import React, { useRef } from "react";

import { useReducedMotion, useScroll, useTransform } from "framer-motion";

import blueLight from "../../assets/images/blue_light.png";
import diamond from "../../assets/images/diamond.gif";
import nightStars from "../../assets/images/night_stars.png";
import rocks from "../../assets/images/rocks.png";
import shineLeft from "../../assets/images/shine_left.png";
import shineRight from "../../assets/images/shine_right.png";
import { ButtonAnchor } from "../ButtonAnchor/ButtonAnchor";

import {
  ButtonWrapper,
  Desc,
  Diamond,
  HeroContent,
  Layer,
  LayerBlueLight,
  Rocks,
  RocksFrame,
  Section,
  ShineLeft,
  ShineRight,
  Title,
} from "./styles";

const HERO_LAYER_BLEED = "300px";
// const NIGHT_STARS_OFFSET_Y = "-200px";
const NIGHT_STARS_OFFSET_Y = "0px";
const BLUE_LIGHT_OFFSET_Y = "400px";
// const NIGHT_STARS_SCROLL_OFFSET_Y = "500px";
const NIGHT_STARS_SCROLL_OFFSET_Y = "600px";
const BLUE_LIGHT_SCROLL_OFFSET_Y = "-25px";

export const HeroSection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const shouldReduceMotion = useReducedMotion();
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start start", "end start"],
  });

  const nightStarsY = useTransform(
    scrollYProgress,
    [0, 1],
    [NIGHT_STARS_OFFSET_Y, NIGHT_STARS_SCROLL_OFFSET_Y],
  );
  const blueLightY = useTransform(
    scrollYProgress,
    [0, 1],
    [BLUE_LIGHT_OFFSET_Y, BLUE_LIGHT_SCROLL_OFFSET_Y],
  );

  return (
    <Section ref={sectionRef}>
      <Layer
        $image={nightStars}
        $zIndex={1}
        $bleed={HERO_LAYER_BLEED}
        style={{ y: shouldReduceMotion ? NIGHT_STARS_OFFSET_Y : nightStarsY }}
      />
      <LayerBlueLight
        $image={blueLight}
        $zIndex={2}
        $bleed={HERO_LAYER_BLEED}
        $position="center bottom"
        style={{ y: shouldReduceMotion ? BLUE_LIGHT_OFFSET_Y : blueLightY }}
      />
      <RocksFrame>
        <Rocks src={rocks} alt="" aria-hidden="true" />
      </RocksFrame>
      <Diamond src={diamond} alt="" aria-hidden="true" />
      <ShineLeft src={shineLeft} alt="" aria-hidden="true" />
      <ShineRight src={shineRight} alt="" aria-hidden="true" />

      <HeroContent>
        <Title>Индивидуальная карьерная стратегия для Топ-менеджеров</Title>
        <Desc>
          Помогаем найти новые возможности для профессионального развития и
          добиваться амбициозных целей
        </Desc>
        <ButtonWrapper>
          <ButtonAnchor
            href="https://t.me/ProhorovaConsult"
            title="Приватная консультация"
          />
        </ButtonWrapper>
      </HeroContent>
    </Section>
  );
};
